import { render } from "./LivestockRecord.vue?vue&type=template&id=1f978b7b&scoped=true"
import script from "./LivestockRecord.vue?vue&type=script&lang=js"
export * from "./LivestockRecord.vue?vue&type=script&lang=js"

import "./LivestockRecord.vue?vue&type=style&index=0&id=1f978b7b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f978b7b"]])

export default __exports__